import './index.scss'
import React from 'react'
import text from './text.json'
import classNames from 'classnames'
import {EventIcon} from '../../../../icons'
import DateHelper from '../../../../utils/date'
import {useSelector} from 'react-redux'
import cronJobRulesetTypes from '../../../../data/cronJobRulesetTypes.json'
import {ImgButton} from '../../../core/button'
import {routes} from '../../../../routes'
import {Link} from 'react-router-dom'

const resultTypes = cronJobRulesetTypes.result.condition.options

const Result = ({type}) =>  (
    <span className={classNames('result-container', resultTypes?.[type]?.value || 'tick')}>
        {resultTypes?.[type]?.label || resultTypes.default.label}
    </span>
)

const JobTable = ({caption, events, jobId}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const selectedTeamId = useSelector(state => state.teams.selectedTeamId)

    const seeMoreLink = () => {
        const lastReceivedAt = events.data.reduce((latest, current) => {
            const latestDate = new Date(latest?.received_at || 0)
            const currentDate = new Date(current?.received_at || 0)
            return latestDate < currentDate ? latest : current
        })?.received_at || ''
        return `${routes.job_events.path}?id=${jobId}&last_received_at=${lastReceivedAt}&team_id=${selectedTeamId}`
    }

    return (
        <div>
            <table className="job-table">
                <caption>
                    {caption}
                </caption>
                <thead>
                    <tr>
                        <th>
                            <div className='heading-cell'>{text.event_time}</div>
                        </th>
                        <th>
                            <div className='heading-cell'>{text.ip}</div>
                        </th>
                        <th>
                            <div className='heading-cell'>{text.result}</div>
                        </th>
                        <th>
                            <div className='heading-cell'>{text.message}</div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        events?.data?.map((row, index) => {
                            return (
                                <tr key={index}>
                                    <td>
                                        <div className={classNames('body-cell', {
                                            dark: isDarkMode
                                        })}>
                                            <EventIcon/>
                                            <span>{DateHelper.convertDateToUTC(row?.received_at)}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={classNames('body-cell', {
                                            dark: isDarkMode
                                        })}>
                                            <span>{row?.ip}</span>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={classNames('body-cell', {
                                            dark: isDarkMode
                                        })}>
                                            <Result type={row?.result}/>
                                        </div>
                                    </td>
                                    <td>
                                        <div className={classNames('body-cell', {
                                            dark: isDarkMode
                                        })}>
                                            <span>{row?.message || 'N/A'}</span>
                                        </div>
                                    </td>
                                </tr>
                            )
                        })
                    }
                </tbody>
            </table>
            <Link to={seeMoreLink()} target='_blank'><ImgButton
                type="button"
                className="load-button"
            >
                {text.see_more}
            </ImgButton></Link>
        </div>)
}

export default JobTable
